// removed by extract-text-webpack-plugin
module.exports = {"header":"_2kJ06 _37W4X _2AJrG","actionHeader":"_1kFfJ _1b0Gt _38618 _3Dqep","selectedCount":"_20mbT -zXOl","allCheckbox":"qLQQf undefined","selected":"_3K4Pi","actionButton":"_17u7u _31ino _1a-AI _3TD8R _38618 _3Dqep"};


//////////////////
// WEBPACK FOOTER
// ./questions/components/ActionHeader.css
// module id = 2010
// module chunks = 3